// components/nodes/overlays/NodeOverlay.jsx
import React from 'react';
import { overlayComponents } from './overlayRegistry';
import Overlay from './Overlay';

const NodeOverlay = ({ data, id, isLocked, selected, showAllModuleOverlays, hidden }) => {
  // if (!isLocked || !selected) return null;

  // Return null if there's no feature or it's the "none" placeholder
  if (!data.feature || data.feature === "none") return null;

  const OverlayComponent = overlayComponents[data.feature];
  
  if (!OverlayComponent) {
    console.log(`No overlay component found for feature: ${data.feature}`);
    return null;
  }

  return (
    <div hidden={hidden}>
      <Overlay>
        <div className='font-normal absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'
        style={{
          zIndex: 1000,
          fontSize: '14px'
        }}
        >
        <OverlayComponent data={data} id={id} showAllModuleOverlays={showAllModuleOverlays} />
      </div>
      </Overlay>
    </div>
  );
};

export default NodeOverlay;